import { createSlice } from '@reduxjs/toolkit';

import axios from 'utils/axiosClient';
import { dispatch } from '../index';

const initialState = {
    error: null,
    fields: [],
    baoCaoTuHocs: [],
    hanhSinhsByNhom: [],
    diemKiemTraHanhSinh: {},
    // Phân biệt "chưa gọi xong API" với "gọi xong nhưng không có điểm". Thiếu cờ này thì
    // popup trang chủ không biết nên đợi hay nên hiện, và sẽ hiện ra khi chưa có điểm.
    diemKiemTraDaTai: false,
    baoCaoTuHocDetails: {},
    submitResult: {},
    createBaoCaoTuHoc: {}
};

const slice = createSlice({
    name: 'baoCaoTuHoc',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },
        getBaoCaoTuHocsSuccess(state, action) {
            state.baoCaoTuHocs = action.payload;
        },
        getDiemKiemTraHanhSinhSuccess(state, action) {
            state.diemKiemTraHanhSinh = action.payload;
            state.diemKiemTraDaTai = true;
        },
        // Gọi hỏng cũng là tải xong: người không có điểm và người gặp lỗi mạng đều không
        // được để popup treo mãi ở trạng thái chờ.
        diemKiemTraTaiXong(state) {
            state.diemKiemTraDaTai = true;
        },
        getBaoCaoTuHocDetailsSuccess(state, action) {
            state.baoCaoTuHocDetails = action.payload;
        },
        getHanhSinhsByNhomSuccess(state, action) {
            state.hanhSinhsByNhom = action.payload;
        },
        resetSubmitResult: (state) => {
            state.submitResult = initialState.submitResult;
        },
        createBaoCaoTuHocSuccess(state, action) {
            state.submitResult = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

export function getBaoCaoTuHocs() {
    return async () => {
        try {
            const response = await axios.get('/baocaotuhoc');
            dispatch(slice.actions.getBaoCaoTuHocsSuccess(response.results));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getDiemKiemTraHanhSinh() {
    return async () => {
        try {
            const response = await axios.get('/ketqua-tuhoc-tutap');
            dispatch(slice.actions.getDiemKiemTraHanhSinhSuccess(response.results[0]));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.diemKiemTraTaiXong());
        }
    };
}

export function getBaoCaoTuHocDetails(id) {
    return async () => {
        try {
            const response = await axios.get(`/baocaotuhoc/${id}`);
            dispatch(slice.actions.getBaoCaoTuHocDetailsSuccess(response));
            return response;
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            return null;
        }
    };
}

export function getBaoCaoTuHocExportUrl(id) {
    return async () => {
        try {
            const response = await axios.post(`/baocaotuhoc/export?baocaoId=${id}`);
            return response;
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getHanhSinhsByNhom(thang) {
    return async () => {
        try {
            const url = thang ? `/baocaotuhoc/gethanhsinhbynhom?thang=${thang}` : '/baocaotuhoc/gethanhsinhbynhom';
            const response = await axios.get(url);

            dispatch(slice.actions.getHanhSinhsByNhomSuccess(response.results));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function createBaoCaoTuHoc(input) {
    return async () => {
        try {
            const response = await axios.post('/baocaotuhoc', { ...input });
            dispatch(slice.actions.createBaoCaoTuHocSuccess(response));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function resetSubmitResult() {
    return async () => {
        dispatch(slice.actions.resetSubmitResult());
    };
}
